import React, { useState } from 'react';
import Type from 'prop-types';
import { IconButton } from "@mui/material";
import { Call as CallIcon } from "@mui/icons-material";
import { useTranslation } from 'hooks';
import { PhoneMenu } from './PhoneMenu';

export const PhoneIconButton = (props) => {
  const { phone, style, size } = props;
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  if (!phone) {
    return null;
  }

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      <IconButton
        color="primary"
        aria-label={t('call')}
        aria-controls="phone-menu"
        aria-haspopup="true"
        onClick={openMenu}
        className={style}
        size={size}
      >
        <CallIcon />
      </IconButton>
      <PhoneMenu
        anchorEl={anchorEl}
        closeMenu={() => setAnchorEl(null)}
        phone={phone}
      />
    </>
  );
};

PhoneIconButton.propTypes = {
  phone: Type.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
  style: Type.any,
  size: Type.oneOf(['small', 'medium']),
};

PhoneIconButton.defaultProps = {
  style: undefined,
  size: 'medium',
};
